"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MailService", {
    enumerable: true,
    get: function() {
        return MailService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _render = require("@react-email/render");
const _templates = /*#__PURE__*/ _interop_require_wildcard(require("~/services/mail/templates"));
const _Mail = require("~/interface/Mail");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _appconfig = /*#__PURE__*/ _interop_require_default(require("~/app.config"));
const _utils = require("~/utils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let MailService = class MailService {
    async getAdapter(ncMeta = _Noco.default.ncMeta) {
        try {
            return await _NcPluginMgrv2.default.emailAdapter(undefined, ncMeta);
        } catch (e) {
            this.logger.error('Email Plugin not configured / active');
            return null;
        }
    }
    async renderMail(template, props) {
        const Component = _templates[template];
        // TODO: Fix Type here
        return await (0, _render.render)(Component(props));
    }
    buildUrl(req, params = {}) {
        var _Noco_getConfig;
        const dashboardPath = (_Noco_getConfig = _Noco.default.getConfig()) == null ? void 0 : _Noco_getConfig.dashboardPath;
        if (params.token && !_appconfig.default.auth.disableEmailAuth) {
            return `${req.ncSiteUrl}${dashboardPath}#/signup/${params.token}`;
        }
        let url = (req == null ? void 0 : req.ncSiteUrl) || process.env.NC_PUBLIC_URL;
        // Reset password link is served from the backend. So no need to append the dashboard path
        if (params.resetPassword) {
            url += `/auth/password/reset/${params.resetPassword}`;
            return url;
        }
        // Email verification link is served from the backend. So no need to append the dashboard path
        if (params.verificationToken) {
            url += `/email/validate/${params.verificationToken}`;
            return url;
        }
        // Below links are served from the frontend. So we need to append the dashboard path
        url += dashboardPath;
        if (params.workspaceId) {
            url += `#/${params.workspaceId}`;
        } else {
            url += `#`;
        }
        if (params.baseId) {
            url += `/${params.baseId}`;
            if (params.tableId) {
                url += `/${params.tableId}`;
                const searchParams = new URLSearchParams();
                if (params.rowId) {
                    searchParams.set('rowId', params.rowId);
                }
                if (params.commentId) {
                    searchParams.set('commentId', params.commentId);
                }
                if (params.columnId) {
                    searchParams.set('columnId', params.columnId);
                }
                if (searchParams.toString()) {
                    url += `?${searchParams.toString()}`;
                }
            }
            if (params.automationId) {
                url += `/workflows/${params.automationId}`;
                if (params.executionId) {
                    const searchParams = new URLSearchParams();
                    searchParams.set('tab', 'logs');
                    searchParams.set('executionId', params.executionId);
                    url += `?${searchParams.toString()}`;
                }
            }
        }
        return url;
    }
    async sendMailRaw(params, ncMeta = _Noco.default.ncMeta) {
        const mailerAdapter = await this.getAdapter(ncMeta);
        if (!mailerAdapter) {
            this.logger.error('Email Plugin not configured / active');
            return false;
        }
        if (!params.to || !params.subject || !params.html && !params.text) {
            this.logger.error('Missing required parameters');
            return false;
        }
        try {
            var _params_cc, _params_bcc;
            await mailerAdapter.mailSend({
                to: params.to,
                subject: params.subject,
                text: params.text,
                html: params.html,
                cc: (0, _nocodbsdk.ncIsArray)(params.cc) ? params == null ? void 0 : (_params_cc = params.cc) == null ? void 0 : _params_cc.join(',') : params == null ? void 0 : params.cc,
                bcc: (0, _nocodbsdk.ncIsArray)(params.bcc) ? params == null ? void 0 : (_params_bcc = params.bcc) == null ? void 0 : _params_bcc.join(',') : params == null ? void 0 : params.bcc,
                attachments: params.attachments
            });
        } catch (e) {
            this.logger.error(e);
            return false;
        }
        return true;
    }
    async sendMail(params, ncMeta = _Noco.default.ncMeta) {
        const mailerAdapter = await this.getAdapter(ncMeta);
        if (!mailerAdapter) {
            this.logger.error('Email Plugin not configured / active');
            return false;
        }
        const { payload, mailEvent } = params;
        try {
            switch(mailEvent){
                case _Mail.MailEvent.BASE_INVITE:
                    {
                        const { base, user, req, token } = payload;
                        const invitee = req.user;
                        await mailerAdapter.mailSend({
                            to: user.email,
                            subject: 'You’ve been invited to a Base',
                            html: await this.renderMail('BaseInvite', {
                                baseTitle: base.title,
                                name: (0, _utils.extractDisplayNameFromEmail)(invitee.email, invitee.display_name),
                                email: invitee.email,
                                link: this.buildUrl(req, {
                                    workspaceId: base.fk_workspace_id,
                                    baseId: base.id,
                                    token
                                })
                            })
                        });
                        break;
                    }
                case _Mail.MailEvent.BASE_ROLE_UPDATE:
                    {
                        const { req, user, base, oldRole, newRole } = payload;
                        const invitee = req.user;
                        await mailerAdapter.mailSend({
                            to: user.email,
                            subject: 'Your Base role has been updated',
                            html: await this.renderMail('BaseRoleUpdate', {
                                baseTitle: base.title,
                                name: (0, _utils.extractDisplayNameFromEmail)(invitee.email, invitee.display_name),
                                email: invitee.email,
                                oldRole: _nocodbsdk.RoleLabels[oldRole],
                                newRole: _nocodbsdk.RoleLabels[newRole],
                                link: this.buildUrl(req, {
                                    workspaceId: base.fk_workspace_id,
                                    baseId: base.id
                                })
                            })
                        });
                        break;
                    }
                case _Mail.MailEvent.RESET_PASSWORD:
                    {
                        const { user, req } = payload;
                        await mailerAdapter.mailSend({
                            to: user.email,
                            subject: 'Reset your password',
                            html: await this.renderMail('PasswordReset', {
                                email: user.email,
                                link: this.buildUrl(req, {
                                    resetPassword: user.reset_password_token
                                })
                            })
                        });
                        break;
                    }
                case _Mail.MailEvent.VERIFY_EMAIL:
                    {
                        const { user, req } = payload;
                        await mailerAdapter.mailSend({
                            to: user.email,
                            subject: 'Verify your email',
                            html: await this.renderMail('VerifyEmail', {
                                email: user.email,
                                link: this.buildUrl(req, {
                                    verificationToken: user.email_verification_token
                                })
                            })
                        });
                        break;
                    }
                case _Mail.MailEvent.WELCOME:
                    {
                        const { req, user } = payload;
                        await mailerAdapter.mailSend({
                            to: user.email,
                            subject: 'Welcome to NocoDB!',
                            html: await this.renderMail('Welcome', {
                                email: user.email,
                                link: this.buildUrl(req, {})
                            })
                        });
                        break;
                    }
                case _Mail.MailEvent.ORGANIZATION_INVITE:
                    {
                        const { req, user, token } = payload;
                        const invitee = req.user;
                        await mailerAdapter.mailSend({
                            to: user.email,
                            subject: 'You have been invited to join NocoDB',
                            html: await this.renderMail('OrganizationInvite', {
                                name: (0, _utils.extractDisplayNameFromEmail)(invitee.email, invitee.display_name),
                                email: invitee.email,
                                link: this.buildUrl(req, {
                                    token
                                })
                            })
                        });
                        break;
                    }
                case _Mail.MailEvent.ORGANIZATION_ROLE_UPDATE:
                    {
                        const { req, user, oldRole, newRole } = payload;
                        const invitee = req.user;
                        await mailerAdapter.mailSend({
                            to: user.email,
                            subject: 'Role updated in NocoDB',
                            html: await this.renderMail('OrganizationRoleUpdate', {
                                name: (0, _utils.extractDisplayNameFromEmail)(invitee.email, invitee.display_name),
                                email: invitee.email,
                                oldRole: _nocodbsdk.RoleLabels[oldRole],
                                newRole: _nocodbsdk.RoleLabels[newRole],
                                link: this.buildUrl(req, {})
                            })
                        });
                        break;
                    }
                case _Mail.MailEvent.FORM_SUBMISSION:
                    {
                        const { formView, data, model, emails, base } = payload;
                        await mailerAdapter.mailSend({
                            to: emails.join(','),
                            subject: `NocoDB Forms: Someone has responded to ${formView.title}`,
                            html: await this.renderMail('FormSubmission', {
                                formTitle: formView.title,
                                tableTitle: model.title,
                                submissionData: data,
                                baseTitle: base.title
                            })
                        });
                        break;
                    }
            }
            return true;
        } catch (e) {
            this.logger.error('Error sending email', e);
            return false;
        }
    }
    constructor(){
        this.logger = new _common.Logger(MailService.name);
    }
};
MailService = _ts_decorate([
    (0, _common.Injectable)()
], MailService);
